import { jsx } from 'react/jsx-runtime';
import React from 'react';

const root = "_root_q8g91_1";
const styles = {
	root: root
};

const InteractiveTags = (props) => {
  const tags = React.Children.toArray(props.children).filter(Boolean).map((child, i) => {
    return jsx("li", { children: child }, i);
  });
  return jsx("ul", { "aria-label": props["aria-label"], className: styles.root, "data-zds": true, children: tags });
};

export { InteractiveTags };
//# sourceMappingURL=InteractiveTags.es.js.map
